/*
  Browse by tub length
  --------------------
  - Click pill => toggles its values in the URL
  - Multiple pills can be active at once
  - Works with AJAX facets re-renders by syncing active state from URL
*/

function splitValues(raw) {
  return String(raw || '')
    .split('||')
    .map((v) => v.trim())
    .filter(Boolean);
}

function resetPills(container) {
  const buttons = container.querySelectorAll('[data-length-range]');
  buttons.forEach((btn) => {
    btn.classList.remove('bg-black', 'text-white');
    btn.classList.add('bg-secondary');
  });
}

function setActivePill(container, btn) {
  btn.classList.remove('bg-secondary');
  btn.classList.add('bg-black', 'text-white');
}

function findFacetsForm(container) {
  return (
    container.closest('section')?.querySelector('facets-form-component') ||
    container.parentElement?.querySelector('facets-form-component') ||
    container.closest('div')?.querySelector('facets-form-component') ||
    document.querySelector('facets-form-component')
  );
}

function removeAllParam(url, paramName) {
  while (url.searchParams.has(paramName)) {
    url.searchParams.delete(paramName);
  }
}

function isSubset(subsetArr, supersetArr) {
  const sup = new Set(supersetArr);
  return subsetArr.every((v) => sup.has(v));
}

function uniquePreserveOrder(arr) {
  const seen = new Set();
  const out = [];
  for (const v of arr) {
    if (!seen.has(v)) {
      seen.add(v);
      out.push(v);
    }
  }
  return out;
}

function syncActivePillFromURL(container) {
  const paramName = container.getAttribute('data-length-param-name');
  if (!paramName) return;

  const url = new URL(window.location.href);
  const currentValues = url.searchParams.getAll(paramName);

  resetPills(container);

  if (!currentValues.length) return;

  const buttons = container.querySelectorAll('[data-length-range]');
  buttons.forEach((btn) => {
    const values = splitValues(btn.getAttribute('data-values'));
    if (!values.length) return;

    if (isSubset(values, currentValues)) {
      setActivePill(container, btn);
    }
  });
}

function applyValuesByURL(container, button) {
  const paramName = container.getAttribute('data-length-param-name');
  if (!paramName) return;

  const pillValues = splitValues(button.getAttribute('data-values'));
  if (!pillValues.length) return;

  const facetsForm = findFacetsForm(container);
  if (!facetsForm) return;

  const url = new URL(window.location.href);
  const currentValues = url.searchParams.getAll(paramName);
  const pillIsActive = isSubset(pillValues, currentValues);

  let nextValues;
  if (pillIsActive) {
    const removeSet = new Set(pillValues);
    nextValues = currentValues.filter((v) => !removeSet.has(v));
  } else {
    nextValues = uniquePreserveOrder([...currentValues, ...pillValues]);
  }

  // Rebuild param values
  removeAllParam(url, paramName);
  nextValues.forEach((v) => url.searchParams.append(paramName, v));

  // Apply using the theme's facets
  if (typeof facetsForm.updateFiltersByURL === 'function') {
    facetsForm.updateFiltersByURL(url.toString());
  } else {
    window.location.href = url.toString();
  }

  // Update pill styling
  syncActivePillFromURL(container);
}

document.addEventListener('click', (e) => {
  const target = e.target instanceof Element ? e.target : null;
  if (!target) return;

  const btn = target.closest('[data-length-range]');
  if (!btn) return;

  const container = btn.closest('[data-browse-length][data-length-param-name]');
  if (!container) return;

  e.preventDefault();
  e.stopPropagation();

  applyValuesByURL(container, btn);
});

/**
 * Initial sync on page load
 */
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-browse-length][data-length-param-name]')
    .forEach(syncActivePillFromURL);
});

/**
 * Re-sync after AJAX facet updates / section re-renders
 */
(function observeBrowseLengthContainers() {
  const observer = new MutationObserver(() => {
    document
      .querySelectorAll('[data-browse-length][data-length-param-name]')
      .forEach(syncActivePillFromURL);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
